import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";

import { Cancel } from "../../../../components";
import { normalizeCommunicationData } from "../../../../../../util/common";

import AuthenticationError from "../AuthenticationError";
import EnterRegistration from "./EnterRegistration";

import Service from "./service";

export const LICENSE_PLATE_CONFIG = {
  NL: {
    countryCode: "NL",
    plateLetter: "NL",
    maxLength: 6,
    minLength: 6,
    plateColor: "#fcb000",
    countryNameBackground: "#007df4",
    borderColor: "#000",
    fontColor: "#1c3e52",
  },
  BE: {
    countryCode: "BE",
    plateLetter: "B",
    maxLength: 7,
    minLength: 1,
    plateColor: "#efefef",
    countryNameBackground: "#007df4",
    borderColor: "#be3034",
    fontColor: "#be3034",
  },
};

const SUBSCREENS = {
  MAIN: 1,
  CANCEL: 2,
  ERROR: 3,
};

export const getPlateConfig = countryCode => LICENSE_PLATE_CONFIG[countryCode || "NL"];

class EnterRegistrationScreen extends Component {
  state = {
    screen: SUBSCREENS.MAIN,
    registrationNumber: "",
    loading: false,
  };

  goToCancel = () => this.setState({ screen: SUBSCREENS.CANCEL });

  goBack = () => this.setState({ screen: SUBSCREENS.MAIN });

  goToErrorScreen = () => this.setState({ screen: SUBSCREENS.ERROR });

  onChange = registrationNumber => {
    const { kiosk } = this.props;
    const { maxLength } = getPlateConfig(kiosk?.country);

    if (registrationNumber.length <= maxLength) this.setState({ registrationNumber });
  };

  handleConfirm = () => {
    const { i18n, match, onGoToNextScreenWithState } = this.props;
    const { registrationNumber } = this.state;

    this.setState({ loading: true }, async () => {
      try {
        const response = await Service.openCheckin({ private_key: match.params.kioskKey, reg_nr: registrationNumber });

        const communication = response?.data?.data || {};

        if (normalizeCommunicationData(communication, i18n)) this.setState({ loading: false }, () => onGoToNextScreenWithState({ communication }));
        else this.setState({ loading: false }, this.goToErrorScreen);
      } catch (err) {
        this.setState({ loading: false }, this.goToErrorScreen);
      }
    });
  };

  render() {
    const { screen, registrationNumber, loading } = this.state;
    const { renderLayout, onAbort, onGoBack, t, kiosk } = this.props;

    const licensePlateConfig = getPlateConfig(kiosk?.country);

    switch (screen) {
      default:
      case SUBSCREENS.MAIN:
        return (
          <EnterRegistration
            renderLayout={renderLayout}
            onGoBack={onGoBack}
            onGoToCancelScreen={this.goToCancel}
            onConfirm={this.handleConfirm}
            registrationNumber={registrationNumber}
            onChange={this.onChange}
            loading={loading}
            licensePlateConfig={licensePlateConfig}
          />
        );

      case SUBSCREENS.CANCEL:
        return <Cancel onGoBack={this.goBack} onAbort={onAbort} />;

      case SUBSCREENS.ERROR:
        return (
          <AuthenticationError
            renderLayout={renderLayout}
            onGoBack={this.goBack}
            message={
              t("kiosk_authentication_error").message || "We could not find a valid appointment to proceed with the check-in, please retry or contact a receptionist"
            }
          />
        );
    }
  }
}

export default withRouter(withTranslation()(EnterRegistrationScreen));
